import { css } from 'styled-components';
import WavyPatternBlack from 'assets/wavy_pattern_black.png';
import WavyPatternWhite from 'assets/wavy_pattern_white.png';

export const AllocationEventStyles = css`
  .b-sch-event-wrap.allocation {
    height: 32px;
    transform: translateY(12px);
    &.isActive {
      z-index: 15;
    }
    &.b-readonly {
      opacity: 1;
      .b-sch-event-content {
        opacity: 1;
      }
    }
    .b-sch-event {
      background-color: var(--cyan-20);
      border-color: var(--cyan-20);
      &.soft:not(:hover) {
        &::after {
          content: '';
          position: absolute;
          background-image: url(${WavyPatternBlack});
          background-size: contain;
          height: 150%;
          width: max(100%, 60px);
          opacity: 9%;
        }

        &::after,
        &::before {
          border-color: var(--cyan-40) !important;
        }
      }
      .content {
        color: var(--cyan-100) !important;
      }
      &:hover {
        background-color: var(--cyan-30);
        border-color: var(--cyan-30);
      }
      &.isActive {
        background-color: var(--blue-60);
        border-color: var(--blue-60);
        outline: 2px solid var(--blue-30);
        outline-offset: 3px;
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--white-100) !important;
        }
        &.soft {
          &::after {
            content: '';
            position: absolute;
            background-image: url(${WavyPatternWhite});
            background-size: contain;
            height: 150%;
            width: max(100%, 60px);
            opacity: 15%;
          }
        }
      }
      &.b-sch-event-selected .b-sch-event-content .content {
        color: var(--cyan-100) !important;
      }
    }
    .over-allocation-bar {
      background: #f44d56;
      position: absolute;
      top: 0;
      height: 4px;
      border-bottom: 1px solid var(--white-100);
      border-right: 2px solid var(--white-100);
    }

    &.b-dragging {
      z-index: 7;
    }
  }
`;
